import React, { useContext } from 'react'
import { Typography } from 'antd'

import IntlMessages from '../../../util/IntlMessages'
import { ThemeContext } from '../../../context/themeContext'
import { DARK_THEME } from '@vacationtracker/shared/constants/ThemeSetting'

import VTLogoPurple from '../../../assets/images/logo-purple.svg'
import VTLogoWhite from '../../../assets/images/logo.svg'

import { ANDROID_MOBILE_APP_URL, IOS_MOBILE_APP_URL } from '../../../constants'

const { Title } = Typography

const MobileApp = (): React.ReactElement => {
  const { theme } = useContext(ThemeContext)

  return (
    <div className="content-mobile-app">
      {theme === DARK_THEME ? <VTLogoWhite style={{ width: '240px' }} /> : <VTLogoPurple style={{ width: '240px' }} />}
      <Title level={3}>
        <IntlMessages id="mobileApp.downloadAppDescription" />
      </Title>
      <div className="content-mobile-app-buttons">
        <a className="ios-banner" href={IOS_MOBILE_APP_URL} target="_blank" rel="noopener noreferrer"></a>
        <a className="android-banner" href={ANDROID_MOBILE_APP_URL} target="_blank" rel="noopener noreferrer"></a>
      </div>
    </div>
  )
}

export default MobileApp
